function getConstructor(obj) {
    const constructor = Object.getPrototypeOf(obj).constructor;
    if (constructor == null) {
        return new Error("Constructor not found.");
    }
    return constructor;
}
/**
 * @internal scope: package
 */
export function getConstructorStaticMember(obj, propertyName) {
    const constructor = getConstructor(obj);
    if (constructor instanceof Error) {
        return constructor;
    }
    if (!Object.hasOwn(constructor, propertyName)) {
        return new Error(`Property ${String(propertyName)} not found on constructor.`);
    }
    return constructor[propertyName];
}
